module.exports = __webpack_public_path__ + "img/sprint-empty-rq.dc127a7f.svg";